export const LEFT_ARROW = '«';
export const RIGHT_ARROW = '»';
export const ELLIPSES = '…';



// WEBPACK FOOTER //
// ./src/modules/paginate/config/linkTypes.js